<template>
  <div
    :style="{
      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee',
      // padding: '10px',
      paddingTop: '20px',
      // paddingTop: '20px',
      position: 'relative',
      bottom: '20px',
      minHeight: '100vh',
      height: 'auto',
      paddingBottom: '20px'
    }"
    id="history"
  >
    <div
      class="padding-5"
      style="height: 200px;"
      :style="{
        backgroundColor: isDarkTheme ? topBgColor : bgTheme,
        borderBottomLeftRadius: '10px',
        borderBottomRightRadius: '10px',
        marginTop: '-20px'
      }"
    ></div>
    <!-- Live Games -->
    <div style="padding: 10px;margin-top: -200px">
      <div
        style="border-radius: 10px;"
        class="live-games bg-light margin-bottom-5"
        v-if="live_tournaments.length"
      >
        <div
          style=" border-top-left-radius: 10px; border-top-right-radius: 10px; font-weight: 400; color: #000000;"
          class="text-uppercase padding-10"
          :style="{ backgroundColor: isDarkTheme ? extraTextColor : '#e8e8e8' }"
        >
          {{ getTranslatedText("live") }}
        </div>
        <div v-for="(lt, index) in live_tournaments" :key="lt.id">
          <div
            class="game align-hor space-between padding-10"
            v-on:click="showLeaderBoard(lt)"
            :style="{
              backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
              borderBottomLeftRadius:
                index === live_tournaments.length - 1 ? '10px' : '0',
              borderBottomRightRadius:
                index === live_tournaments.length - 1 ? '10px' : '0'
            }"
          >
            <div class="logo center-align-self">
              <img
                class="extra-large-icon full-width"
                :src="lt.game_thumb_url"
              />
            </div>
            <div
              style="padding-left: 4px;  width: 72%;"
              class="align-ver text-left text-semi-small"
            >
              <div
                style="margin-bottom: 2px; font-weight: 500; color: #000000;"
              >
                {{ lt.title }}
              </div>
              <div
                style="border-bottom: 1px solid #787676; font-size: 14px; font-weight: 600; color: #000000;"
                class="timing text-uppercase margin-bottom-5 padding-bottom-5"
              >
                {{ lt.timing.start.time }} {{ lt.timing.start.date }} -
                {{ lt.timing.end.time }} {{ lt.timing.end.date }}
              </div>
              <div
                style="text-align: center !important;"
                class="align-hor space-between"
              >
                <div class="margin-right-10">
                  <div style="margin-right: 5px;">
                    <div
                      class="padding-bottom-5"
                      style="font-weight: 700; color: #000000;"
                    >
                      {{ getTranslatedText("Total Prize") }}
                    </div>
                    <!-- <div style="text-align: center;" class="text-uppercase">
                      ₹{{ lt.total_prize }}
                    </div> -->
                    <div>
                      <template v-if="lt.prize_type === 'Cash'">
                        <p
                          style="margin: 0px !important; font-weight: 600; color: #000000;"
                        >
                          ₹{{ lt.total_prize }}
                        </p>
                      </template>

                      <template v-else>
                        <p
                          style="margin: 0px !important; font-weight: 600; color: #000000;"
                        >
                          {{ formatNumber(lt.total_prize) }} {{ lt.prize_type }}
                        </p>
                      </template>
                    </div>
                  </div>
                </div>
                <div style="margin-right: 5px;">
                  <div
                    class="padding-bottom-5"
                    style="font-weight: 700; color: #000000;"
                  >
                    {{ getTranslatedText("Entry Fee") }}
                  </div>
                  <div
                    class="text-uppercase"
                    style="text-align: center; font-weight: 600; color: #000000;"
                  >
                    <!-- {{
                      lt.entry_fee == 0
                        ? getTranslatedText("FREE")
                        : lt.entry_fee
                    }} -->
                    {{ lt.entry_fee == 0 ? "FREE" : lt.entry_fee }}
                  </div>
                </div>
                <div>
                  <div
                    class="padding-bottom-5"
                    style="font-weight: 700; color: #000000;"
                  >
                    {{ getTranslatedText("Your Rank") }}
                  </div>
                  <div class="text-green align-center pointer">
                    #{{ lt.your_rank }}
                  </div>
                </div>
              </div>
            </div>
            <div class="text-uppercase text-light">
              <!-- <div class="tag padding-0515">{{getTranslatedText('live')}}</div> -->
            </div>
          </div>
          <!-- <hr class="custom-hr"> -->
          <div
            class="modal center-hor align-ver"
            v-show="lt.leaderboard"
            v-on:click.self="hideLeaderBoard(lt)"
          >
            <!-- <leader-board
              v-show="lt.leaderboard && lt.leaderboard_data.length > 0"
              :model="lt.leaderboard_data"
            ></leader-board> -->
            <leader-board
              v-show="lt.leaderboard && lt.leaderboard_data.length > 0"
              :model="lt.leaderboard_data"
              :shareText="shareText"
              :offerId="3"
              :gameName="lt.title"
            />

            <!-- <leader-board
              v-show="lt.leaderboard && lt.leaderboard_data.length > 0"
              :model="lt.leaderboard_data"
              :shareText="shareText"
              :shareLink="shareLink"
            ></leader-board> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Completed Games -->
    <div
      style="border-radius: 10px;margin: 0px 10px !important;"
      class="live-games  bg-light margin-bottom-5"
      v-if="completed_tournaments.length"
    >
      <div
        style=" border-top-left-radius: 10px; border-top-right-radius: 10px; font-weight: 400; color: #000000;"
        :style="{ backgroundColor: isDarkTheme ? extraTextColor : '#e8e8e8' }"
        class="text-uppercase padding-10 bottom-border"
      >
        {{ getTranslatedText("completed") }}
      </div>
      <div v-for="(ct, index) in completed_tournaments" :key="ct.id">
        <div
          class="game align-hor padding-10"
          v-on:click="showLeaderBoard(ct)"
          :style="{
            backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
            gap: '10px',
            borderBottomLeftRadius:
              index === completed_tournaments.length - 1 ? '10px' : '0',
            borderBottomRightRadius:
              index === completed_tournaments.length - 1 ? '10px' : '0'
          }"
        >
          <div class="logo center-align-self">
            <img class="extra-large-icon full-width" :src="ct.game_thumb_url" />
          </div>
          <div
            style="padding-left: 4px;  width: 72%;"
            class="align-ver text-left text-semi-small"
          >
            <div
              class="margin-bottom-10"
              style="font-weight: 500; color: #000000;"
            >
              {{ ct.title }}
            </div>
            <div
              style="border-bottom: 1px solid #787676; font-size: 14px; font-weight: 600; color: #000000;"
              class="timing text-uppercase margin-bottom-5 padding-bottom-5"
            >
              {{ ct.timing.start.time }} {{ ct.timing.start.date }} -
              {{ ct.timing.end.time }} {{ ct.timing.end.date }}
            </div>
            <!-- <hr class="custom-hr" /> -->
            <div
              style="text-align: center !important;"
              class="align-hor space-between"
            >
              <div class="margin-right-10">
                <div
                  class="padding-bottom-5"
                  style="font-weight: 700; color: #000000;"
                >
                  {{ getTranslatedText("Total Prize") }}
                </div>
                <!-- <div class="container">
                  <img
                    class="semi-large-icon"
                    src="@/assets/ticket-white.svg"
                  />
                  <div class="centered">&#8377{{ ct.total_prize }}</div>
                </div> -->
                <div>
                  <template v-if="ct.prize_type === 'Cash'">
                    <p
                      style="margin: 0px !important; font-weight: 600; color: #000000;"
                    >
                      ₹{{ formatNumber(ct.total_prize) }}
                    </p>
                  </template>

                  <template v-else style="font-weight: 800;">
                    <p
                      style="margin: 0px !important; font-weight: 600; color: #000000;"
                    >
                      {{ formatNumber(ct.total_prize) }} {{ ct.prize_type }}
                    </p>
                  </template>
                </div>
              </div>
              <!-- <div>&#8377{{ ct.total_prize }}</div>
              </div> -->
              <div class="margin-right-10">
                <div
                  class="padding-bottom-5"
                  style="font-weight: 700; color: #000000;"
                >
                  {{ getTranslatedText("Entry Fee") }}
                </div>
                <div
                  class="text-uppercase"
                  style="font-weight: 600; color: #000000;"
                >
                  <!-- {{
                    ct.entry_fee == 0 ? getTranslatedText("FREE") : ct.entry_fee
                  }} -->
                  {{ ct.entry_fee == 0 ? "FREE" : ct.entry_fee }}
                </div>
              </div>
              <div>
                <div
                  class="padding-bottom-5"
                  style="font-weight: 700; color: #000000;"
                >
                  {{ getTranslatedText("Your Rank") }}
                </div>
                <div
                  class="text-green"
                  style="font-weight: 800; font-size: 14px;"
                >
                  #{{ ct.your_rank }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="modal center-hor align-ver"
          v-show="ct.leaderboard"
          v-on:click.self="hideLeaderBoard(ct)"
        >
          <leader-board
            v-show="ct.leaderboard && ct.leaderboard_data.length > 0"
            :model="ct.leaderboard_data"
            :gameName="ct.title"
          ></leader-board>
        </div>
      </div>
    </div>

    <div
      class="margin-5 align-ver center-hor"
      v-if="!live_tournaments.length && !completed_tournaments.length"
      :style="{
        backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
        height: '90vh',
        borderRadius: '10px'
      }"
      style="margin-right: 10px; margin-left: 10px;"
    >
      <div
        :style="{
          backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
        }"
        class="align-ver center-hor bg-light border-radius-5"
      >
        <div
          style="display: flex; justify-content: center; align-items: center; width: 100%"
          :style="{
            backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
          }"
        >
          <img src="@/assets/no-data.svg" class="w20" style="width: 20%;" />
        </div>
        <div class="font-bold">You haven't played any game yet!</div>
      </div>
    </div>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import LeaderBoard from "@/components/leader-board";
import axios from "axios";
export default {
  mixins: [globals],
  components: {
    "leader-board": LeaderBoard
  },
  data() {
    return {
      live_tournaments: [],
      completed_tournaments: [],
      isOpen: false,
      page: 1,
      tournament_data: {},
      shareText: "",
      shareLink: ""
    };
  },
  methods: {
    formatNumber(value) {
      if (value >= 1000) {
        return (value / 1000).toFixed(value % 1000 === 0 ? 0 : 1) + "k";
      }
      return value.toString();
    },
    getTournamentHistory() {
      var self = this;
      // no user yet (SDK still waiting for init data); the extUid watcher retries
      if (!self.isValidRequest) {
        return;
      }
      var url =
        this.$store.getters.gamesDomain +
        "/v2/web_games_history?partner=" +
        self.partnerID +
        "&contact_number=" +
        self.extUid;
      if (self.gameID) {
        url += "&game_id=" + self.gameID;
      }
      if (self.langCode) {
        url += "&lang=" + self.langCode;
      }
      var headers = this.$store.getters.headers;
      axios
        .get(url, {
          headers: headers
        })
        .then(resp => {
          if (resp.status == 200 && resp.data.success) {
            var data = resp.data;

            this.shareText = data.share_text;
            // this.tournament_data = resp.data;
            self.$store.state.totalUserPoints = data.total_user_points;
            var all_live_tournaments = data.live;
            if (all_live_tournaments.length > 0) {
              all_live_tournaments.forEach(function(v) {
                v.timing = self.getFormattedDateTime(v.starts_at, v.ends_at);
                v.leaderboard = false;
                var tempObj = {};
                tempObj.id = v.your_id;
                tempObj.name = v.your_name;
                tempObj.mobile = v.your_contact_number;
                tempObj.rank = v.your_rank;
                tempObj.prize = v.your_prize;
                tempObj.score = v.your_score;
                tempObj.prize_type = v.your_prize_type;
                v.leaderboard_data.unshift(tempObj);
              });
            }
            self.live_tournaments = all_live_tournaments;
            self.tournament_data = data;

            var all_completed_tournaments = data.completed;
            if (all_completed_tournaments.length > 0) {
              all_completed_tournaments.forEach(function(v) {
                v.timing = self.getFormattedDateTime(v.starts_at, v.ends_at);
                v.leaderboard = false;
                var tempObj = {};
                tempObj.id = v.your_id;
                tempObj.name = v.your_name;
                tempObj.mobile = v.your_contact_number;
                tempObj.rank = v.your_rank;
                tempObj.prize = v.your_prize;
                tempObj.score = v.your_score;
                tempObj.prize_type = v.your_prize_type;
                v.leaderboard_data.unshift(tempObj);
              });
            }
            self.completed_tournaments = all_completed_tournaments;
          } else {
            self.alertPopup(true, resp.data.message);
          }
        })
        .catch(err => {});
    },
    showLeaderBoard(game) {
      game.leaderboard = true;
      var prize;
      this.messageToShare(game.your_prize, game.your_prize_type, game.title);
    },
    hideLeaderBoard(game) {
      game.leaderboard = false;
      this.messageToShare("", "", "");
    },
    extractLink(text) {
      // Regex to match http or https URLs
      var regex = /(https?:\/\/[^\s]+)/;
      var match = text && text.match(regex);
      return match ? match[0] : "";
    },
    getShareLink(offerId = 3) {
      var baseDomain = this.$store.getters.gamesDomain.replace("/v2", "");
      var url = baseDomain + "/get_share_link/?offer_id=" + offerId;
      var headers = this.$store.getters.headers;

      return axios
        .get(url, { headers: headers })
        .then(resp => {
          if (resp.status === 200 && resp.data.success) {
            var fullMessage = resp.data.message;

            // EXTRACT LINK ONLY
            var link = this.extractLink(fullMessage);

            console.log("Extracted Link:", link);

            this.shareLink = link; // store only link in component

            return link;
          }
          return "";
        })
        .catch(err => {
          console.log("Share Link API Error:", err);
          return "";
        });
    }
  },
  created() {
    clearInterval(this.$store.state.refreshTournamentTimer);
    this.$store.state.headTitle = "Tournament History";
    this.$store.state.history = false;
    this.$store.state.showHistory = false;
    this.$store.state.showWallet = false;
    this.getTournamentHistory();
    this.getShareLink();
  },
  watch: {
    extUid(val) {
      if (val) {
        this.getTournamentHistory();
      }
    }
  },
  computed: {
    topBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null;
    },
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.offersCardBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    extraTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.extraTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.extraTextColor;
      }
      return null; // fallback
    }
  }
};
</script>

<style>
.tag {
  background: #f24972;
}
.logo {
  height: 80px;
  width: 80px;
}
.tags {
  min-width: 60px;
}
#history .ranking-rewards {
  border-collapse: collapse;
  width: 100%;
}
#history .ranking-rewards td {
  padding: 5px 10px;
}
#history .ranking-rewards tr:nth-child(2) {
  --bgcolor: #666666;
  background-color: var(--bgcolor);
  color: #ffffff;
}
</style>
